
import { Vue, Component } from "vue-property-decorator";
import api from "@/api/index";
import {
  OrganizationUnitDto, ProfitReportStandardDto, ProfitType
} from "@/api/appService";
const ouKey = "Abp-OrganizationUnitId";
import Cookies from "js-cookie";
import XLSX, {WritingOptions} from 'xlsx'
import {WriteFileOptions} from "fs";
import ExportTableHtml from "@/components/ExportTableHtml/index.vue";
import ReportTable from "@/views/report/component/report-table.vue";
import ReportTip from "@/views/report/component/report-tip.vue";
export const getOu = () => Cookies.get(ouKey);
@Component({
  components: {ReportTip, ReportTable, ExportTableHtml}
})
export default class ProjectDetail extends Vue {
  detail: ProfitReportStandardDto[] = [];
  storesList: OrganizationUnitDto[] = [];
  queryForm: any = {
    year: undefined,
    organizationUnitId: undefined
  };
  loading:boolean=true;
  showOrganizationUnitChoose:boolean = false;

  get profitType(){
    return ProfitType.Store;
  }

  async created() {

    const ou = this.$store.getters['user/ou'] as OrganizationUnitDto;
    if(ou && ou.level === '门店'){
      this.showOrganizationUnitChoose = false;
    } else {
      this.showOrganizationUnitChoose = true;
    }


    if(this.showOrganizationUnitChoose){
      await this.fetchStores();
      if(this.storesList.length>0){
        this.queryForm.organizationUnitId = this.storesList[0].id;
      }
    } else {
      this.queryForm.organizationUnitId = ou.id;
    }

    this.queryForm.year = new Date().getFullYear();

    if(this.queryForm.organizationUnitId){
      await this.fetchDetail();
    }
  }

  async fetchDetail() {
    this.loading = true;
    await api.profitReport
      .getProfitOfStore({
        year: this.queryForm.year,
        organizationUnitId: this.queryForm.organizationUnitId
      })
      .then(res => {
        this.loading = false;
        this.detail = res!;

      });
  }

  // 搜索
  async handleSearch() {
    await this.fetchDetail();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      year: new Date().getFullYear(),
      organizationUnitId: Number(getOu())
    };
    await this.fetchDetail();
  }

  async fetchStores() {
    return api.organizationUnit.getStoresBySession().then(res => {
      this.storesList = res;
    });
  }

}
